import { render } from "./TInlineMessage.vue?vue&type=template&id=4c43b631&scoped=true"
import script from "./TInlineMessage.vue?vue&type=script&lang=js"
export * from "./TInlineMessage.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c43b631"]])

export default __exports__